import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/IKEA_festival_Plaza.webp';

const Project_one = () => {

  return (
    <>
    
          <div className='project_1_work' id="workBanner">
    
            <div className="container project_our_work">
    
              <div className="heading">
                <h1>IKEA Festival Plaza</h1>
              </div>
    
              <hr></hr>
              <div className='project_section'>
                <div className="project_section_content">
                  <h1 className="project_scope">Scope of Work</h1>
                  <p>IKEA's flagship Dubai store at Festival Plaza — one of the largest IKEA outlets in the Middle East at 64,000 sqm. Part of the
                    Majid Al Futtaim-developed Festival Plaza retail destination in Al Barsha, serving Dubai's western residential catchment.</p>
                  <p>MAIN CONTRACTOR : -</p>
                  <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                  <p>GEMCO SCOPE OF WORKS : Main central plant room works</p>
                  {/* <h2 className="project_years">2014 – 2022</h2> */}
                </div>
                <div className='project_1_card'>
                  <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                </div>
              </div>
            </div>
          </div>
    
        </>
    
  )
}

export default Project_one